module.exports = __webpack_public_path__ + "img/ring_g_skip_null_1.effb72c8.png";